module.exports = __webpack_public_path__ + "681e9cf18457d59d54f66057fbf723f3.svg";